@let modelData = model();
@let columnData = column();

@switch (columnData.key) {
  @case (getColumnKey('number')) {
    <app-router-link
      [route]="Route.PL_AccountSubscriptionDetails"
      [params]="detailsParams()">
      <div
        pTooltip="Kliknij, aby wyświetlić szczegóły"
        class="text-[#3858E9] underline decoration-dotted">
        {{ modelData.number }}
      </div>
    </app-router-link>
  }

  @case (getColumnKey('status')) {
    @if (modelData.isLocked) {
      <div class="inline-flex text-sm font-bold text-orange-600 uppercase">
        Przetwarzanie
      </div>
    } @else {
      <app-subscription-status [status]="modelData.status" />
    }
  }

  @case (getColumnKey('totalPrice')) {
    <div class="flex gap-1">
      <app-currency [amount]="modelData.totalPrice" />
      <span>/</span>
      <span>miesiąc</span>
    </div>
  }

  @default {
    <app-table-body-no-reference-cell [columnKey]="columnData.key" />
  }
}
